import { Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Button, Form, Grid, Header, Modal, Segment } from 'semantic-ui-react';
import { WorkLevel } from '../../models/workLevel';
import { useStore } from '../../stores/store';
// import MySelectInput from "../form/MySelectInput";
import MyTextInput from '../form/MyTextInput';
// import MyYearInput from "../form/MyYearInput";
import * as Yup from 'yup';
import { v4 as uuid } from 'uuid';
// import { languageOptions,originOptions } from "../options/countrystateOptions/languageOptions";
import sendRespectiveEmail from '../../models/EmailNew';
import { userLanguage } from '../userLanguageSchema/userLanguage';
//import commonStore from "../../stores/commonStore";

function WorkLevelMasterModal() {
  const [, setOpen] = useState(false);
  const initialdata = {
    id: '',
    title: '',
    year: '',
    language: '',
    originIndia: '',
    isActive: true,
    isDeleted: false,
    isMaster: false,
  };
  const { dashboardStore, WorkLevelStore, commonStore } = useStore();

  //  WorkLevel state
  const [workLevelData, setWorkLevelData] = useState<WorkLevel>(initialdata);

  const handleChange = (e: any, data: any) => {
    if (data === undefined) {
      const newArr = {
        ...workLevelData,
        [e.target.name]: e.target.value,
      };
      setWorkLevelData(newArr);
    } else {
      const newArr = {
        ...workLevelData,
        isMaster: data.checked,
      };
      setWorkLevelData(newArr);
    }
  };
  // setting the selected WorkLevel value to state
  const handleFormSubmit = (values: WorkLevel) => {
    // const originIndia=values.originIndia==="Indian"?true:false;
    if (values.id === '') {
      // WorkLevel id is null for creating WorkLevel
      const newworkLevelData = {
        ...values,
        id: uuid(),
      };
      dashboardStore.setWorkLevelMaster(newworkLevelData);
      WorkLevelStore.createWorkLevel(newworkLevelData);
      sendRespectiveEmail(
        'created',
        newworkLevelData.title,
        'created WorkLevel',
        '',
      ); //email Function
      // setting the state to initial value for form reset
      setWorkLevelData(initialdata);
      dashboardStore.setOpenWorkLevelMasterModal(false);
    }
  };
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboardStore.dashboard.openWorkLevelMasterModal}
    >
      <Segment clearing responsive={true}>
        <Header
          icon="edit"
          size="huge"
          dividing
          as="h1"
          content={
            commonStore.hfcCustomerChanges
              ? 'TITLE MASTER'
              : (
                  userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster
                    ?.IRVWLL01 as any
                )?.[`${commonStore.language.key}`]
          } //'Work Level Master'
          //label={(userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster?.IRVWLL01 as any)?.[`${commonStore.language.key}`]}//'Work Level Master'
          sub
          color="grey"
        />
        <Formik
          initialValues={workLevelData}
          enableReinitialize={true}
          onSubmit={(values) => {
            handleFormSubmit(values);
          }}
          validationSchema={Yup.object({
            title: Yup.string().required(),
            // year: Yup.string().required(),
            // language: Yup.string().required(),
          })}
        >
          {({ handleSubmit, isSubmitting, isValid, dirty }) => (
            <Form
              className="ui form error"
              onSubmit={handleSubmit}
              autoComplete="off"
            >
              <Grid container columns={1}>
                <Grid.Column>
                  <MyTextInput
                    name="title"
                    label={`Add ${(
                      userLanguage[0]
                        .Level3InventoryRecievingVerifyWorkLevelMaster
                        ?.IRVWLL02 as any
                    )?.[`${commonStore.language.key}`]}`} //Title
                    placeholder={`Add ${(
                      userLanguage[0]
                        .Level3InventoryRecievingVerifyWorkLevelMaster
                        ?.IRVWLLTB01 as any
                    )?.[`${commonStore.language.key}`]}`} //Title
                    onChange={handleChange}
                  />
                </Grid.Column>
                {/* <Grid.Column> <MyYearInput  
              name='year' 
              title={(userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster?.IRVWLL03 as any)?.[`${commonStore.language.key}`]}//"Year" 
              placeholderText={(userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster?.IRVWLLTB02 as any)?.[`${commonStore.language.key}`]}//'Year'  
              showYearPicker dateFormat="yyyy"/>
             </Grid.Column> */}
                {/* <Grid.Column> 
                 <MySelectInput 
                  name='language' 
                  label={(userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster?.IRVWLL04 as any)?.[`${commonStore.language.key}`]}//'Language'  
                  placeholder={(userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster?.IRVWLLDD01 as any)?.[`${commonStore.language.key}`]}//'Language' 
                 options={languageOptions} /> </Grid.Column> */}
              </Grid>
              {/* <Grid container columns={1} >
            <Form.Checkbox label='isMaster' checked={workLevelData.isMaster}  name="isMaster"  onChange={handleChange}/>
            <Grid.Column> 
              <MySelectInput 
              name='originIndia' 
              label={(userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster?.IRVWLL05 as any)?.[`${commonStore.language.key}`]}//'Origin'
              placeholder={(userLanguage[0].Level3InventoryRecievingVerifyWorkLevelMaster?.IRVWLDD02 as any)?.[`${commonStore.language.key}`]}//'Origin'  
              options={originOptions}/> </Grid.Column>
                </Grid>*/}
              <Button.Group floated="right" style={{ marginTop: '40px' }}>
                <Button
                  onClick={() =>
                    dashboardStore.setOpenWorkLevelMasterModal(false)
                  }
                  //Cancel
                >
                  {' '}
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingVerifyWorkLevelMaster
                        ?.IRVWLB01 as any
                    )?.[`${commonStore.language.key}`]
                  }{' '}
                </Button>
                <Button.Or
                  text={
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingVerifyWorkLevelMaster
                        ?.IRVWLB02 as any
                    )?.[`${commonStore.language.key}`]
                  }
                />
                <Button
                  disabled={isSubmitting}
                  loading={isSubmitting}
                  type="submit"
                  content="Submit"
                  positive
                  //Submit
                >
                  {
                    (
                      userLanguage[0]
                        .Level3InventoryRecievingVerifyWorkLevelMaster
                        ?.IRVWLB03 as any
                    )?.[`${commonStore.language.key}`]
                  }{' '}
                </Button>
              </Button.Group>
            </Form>
          )}
        </Formik>
      </Segment>
    </Modal>
  );
}

export default observer(WorkLevelMasterModal);
